export const CheckCircleTwo = (): JSX.Element => {
  const className = 'icons indexed-icons--check-circle';

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M6 8L7.33333 9.33333L10 6.66667M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
        stroke="#29A429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
